import { render, staticRenderFns } from "./test-table.vue?vue&type=template&id=2e262a12&lang=html&"
import script from "./test-table.vue?vue&type=script&lang=js&"
export * from "./test-table.vue?vue&type=script&lang=js&"
import style0 from "./test-table.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports